import {View} from 'MWC';
import tpl from '../templates/main';

export default class extends View {
    template = tpl;

    constructor(props) {
        super(props);
    }

    static displayName = 'Header.Views.MobileInsideMenu';
}
